class Attack {
  public name: string;
  public numModels: number;
  public numAttacks: string;
  public hitType: string;
  public woundType: string;
  public rend: number;
  public damage: string;
  public critType: string;
  public rangeType: string;
  public isCompanion: boolean;
  public hasChargeDamage: boolean;
  public hasChampion: boolean;

  constructor(
    name: string,
    numModels = 1,
    numAttacks = '1',
    hitType = '6+',
    woundType = '6+',
    rend = 0,
    damage = '1',
    rangeType = 'MELEE',
    critType = 'None',
    isCompanion = false,
    hasChargeDamage = false,
    hasChampion = false
  ) {
    this.name = name;
    this.numModels = numModels;
    this.numAttacks = numAttacks;
    this.hitType = hitType;
    this.woundType = woundType;
    this.rend = rend;
    this.damage = damage;
    this.rangeType = rangeType;
    this.critType = critType;
    this.isCompanion = isCompanion;
    this.hasChargeDamage = hasChargeDamage;
    this.hasChampion = hasChampion;
  }
}

export default Attack;